import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { StationEntity } from ".";

const dataClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedStationEntity(station_id: number): Promise<StationEntity | null> {
  let entity: any = await cache.get(station_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const station = await dataClient.get_stations_station_id(station_id);
    if (station !== null) {
      entity = new StationEntity(station_id, station);
      cache.put(station_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCachedStationListBySearchString(searchstring: string, strict: boolean): Promise<any> {
  const list = await dataClient.get_stations_by_string(searchstring, strict);
  let entities = [];
  if (list !== null) {
    for (const y of list) {
      entities.push(y.stationID);
    }
    if (entities.length) {
      return entities;
    } else {
      return [];
    }
  }
}
